import api from '../api';

/**
 * PATCH application stage; sends multipart when joining/relief documents are attached.
 */
export async function patchApplicationStage(id, payload) {
  const hasFiles = payload.appointmentLetterFile || payload.exitDocumentFile;

  if (!hasFiles) {
    const { appointmentLetterFile, exitDocumentFile, ...json } = payload;
    return api.patch(`/applications/${id}/stage`, json).then(r => r.data);
  }

  const form = new FormData();
  const jsonFields = [
    'stage',
    'note',
    'rejectionReasonCode',
    'rejectionComment',
    'notSelectedReasonCode',
    'notSelectedComment',
    'joiningDate',
    'lastWorkingDay',
    'reliefNote'
  ];

  for (const key of jsonFields) {
    const value = payload[key];
    if (value === undefined || value === null) continue;
    if (value === '' && key !== 'note') continue;
    form.append(key, value);
  }

  if (payload.interviewAssessment) {
    form.append('interviewAssessment', JSON.stringify(payload.interviewAssessment));
  }
  if (payload.offerDetails) {
    form.append('offerDetails', JSON.stringify(payload.offerDetails));
  }
  if (payload.interviewSchedule) {
    form.append('interviewSchedule', JSON.stringify(payload.interviewSchedule));
  }

  if (payload.appointmentLetterFile) {
    form.append('appointmentLetter', payload.appointmentLetterFile);
  }
  if (payload.exitDocumentFile) {
    form.append('exitDocument', payload.exitDocumentFile);
  }

  return api.patch(`/applications/${id}/stage`, form).then(r => r.data);
}

/** Forward a screened submission to the client (admin/recruiter). */
export async function submitApplicationToClient(id, note = '') {
  return api.post(`/applications/${encodeURIComponent(id)}/submit-to-client`, { note }).then(r => r.data);
}
